import { THEME_BLUE_PURPLE, THEME_ORANGE_RED } from './constants';

const baseTheme = {
  theme: {
    colors: [],
    chart: {
      backgroundColor: 'rgba(255,255,255, 0)',
      borderWidth: 0,
      plotBorderWidth: 0,
      margin: 0,
      height: null,
      style: {
        fontFamily: 'Futura, sans-serif',
      },
    },
    tooltip: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      series: {
        borderWidth: 0,
        pointPadding: 0.2,
      },
      bar: {
        pointWidth: 32,
      },
    },
    title: {
      text: '',
    },
  },
  xAxisLabelStyles: {
    labels: {
      x: 0,
      align: 'left',
      reserveSpace: false,
      y: -25,
      style: {
        color: 'white',
        font: '14px Futura, sans-serif',
        fontWeight: 'bold',
        whiteSpace: 'nowrap',
        textOutline: 'none',
      },
    },
    lineWidth: 0,
  },
  yAxisLabelStyles: {
    title: {
      text: '',
    },
    gridLineWidth: 0,
    labels: {
      enabled: false,
    },
  },
  dataLabels: {
    enabled: true,
    inside: false,
    align: 'left',
    verticalAlign: 'middle',
    x: 5,
    format: '{y}',
    style: {
      color: 'white',
      font: 'Futura, sans-serif',
      fontSize: '18px',
      fontWeight: 'normal',
      whiteSpace: 'nowrap',
      textOutline: 'none',
    },
  },
};

const themes = {
  [THEME_ORANGE_RED]: {
    ...baseTheme,
    theme: {
      ...baseTheme.theme,
      colors: [
        {
          linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
          stops: [
            [0, '#f76500'],
            [1, '#d80100'],
          ],
        },
      ],
    },
    // focusBarColor: {
    //   linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
    //   stops: [
    //     [0, '#5b3a84'],
    //     [1, '#ae044d']
    //   ]
    // }
  },
  [THEME_BLUE_PURPLE]: {
    ...baseTheme,
    theme: {
      ...baseTheme.theme,
      colors: [
        {
          linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
          stops: [
            [0, '#bac2cc'],
            [1, '#a56ca6'],
          ],
        },
      ],
    },
    // focusBarColor: {
    //   linearGradient: { x1: 0, x2: 1, y1: 0, y2: 0 },
    //   stops: [
    //     [0, '#5b3a84'],
    //     [1, '#ae044d']
    //   ]
    // }
  },
};

export default themes;
